// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	ES_HOST: 'http://localhost:9200',
	RESULTS_PER_PAGE: 10,
	// apiUrl: 'https://www.zdslogic-development.com:8080/ng8-spring-server/api'
	// apiUrl: 'https://www.zdslogic-development.com:8080/spring-boot-docker-server/api'
	// apiUrl: 'http://www.veteransofhope.us/ng8-spring-server/api'
	// apiUrl: 'http://localhost:8080/ng9-spring-server/api'
	//redirectUri: 'http://localhost',
	redirectUri: 'https://www.veteransofhope.us',
	//ssoUrl: 'http://localhost:18080/auth',

	apiUrl: 'http://localhost:8085/zdslogic-server/api',

	//microservices

	articlesApiUrl: 'http://localhost:8085/zdslogic-server/api',
	assignmentsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	authenticationApiUrl: 'http://localhost:8085/zdslogic-server/api',
	booksApiUrl: 'http://localhost:8085/books-server/api',
	calendarApiUrl: 'http://localhost:8085/books-server/api',
	classroomApiUrl: 'http://localhost:8085/zdslogic-server/api',
	commonApiUrl: 'http://localhost:8085/zdslogic-server/api',
	configApiUrl: 'http://localhost:8085/zdslogic-server/api',
	contactsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	dashApiUrl: 'http://localhost:8085/zdslogic-server/api',
	emailsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	employeessApiUrl: 'http://localhost:8085/zdslogic-server/api',
	inventoryApiUrl: 'http://localhost:8085/zdslogic-server/api',
	jobsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	logsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	messagingApiUrl: 'http://localhost:8085/zdslogic-server/api',
	profilesApiUrl: 'http://localhost:8085/zdslogic-server/api',
	projectsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	resumesApiUrl: 'http://localhost:8085/zdslogic-server/api',
	schedulerApiUrl: 'http://localhost:8085/zdslogic-server/api',
	shopApiUrl: 'http://localhost:8085/zdslogic-server/api',
	skillsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	studioApiUrl: 'http://localhost:8085/zdslogic-server/api',
	subscriptionsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	systemsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	teamsApiUrl: 'http://localhost:8085/zdslogic-server/api',
	trainingApiUrl: 'http://localhost:8085/zdslogic-server/api',
	weatherApiUrl: 'http://localhost:8085/zdslogic-server/api',
	wikiApiUrl: 'http://localhost:8085/zdslogic-server/api',

	ssoUrl: 'https://www.veteransofhope.us/keycloak/auth',

	// apiUrl: 'http://www.veteransofhope.us/zdslogic-server/api',
	wsUrl: 'https://localhost:8085/zdslogic-server/live',

	// wsUrl: 'http://www.veteransofhope.us/zdslogic-server/live'
	socketUrl: '/',
	baseURL: 'http://localhost:8085/zdslogic-server/api',
	originHeader: 'https://veteransofhope.us',
	siteKey: '6LekHPgZAAAAAF22P6SL0snnu1stiwZkYN-slvea',
	
	Paypal_Client_ID: 'AaF885UFkgJdAiyTTWGW6b49Idr_gR8ojNELxI2STm569J-L3BAp_ZCbuE6_TgCzmuZlYfGF8-2z-YLC',
    	Paypal_Client_Secret: 'EEU6p2FEO5VYGsbXwEwrmF_hdZpq1l1mAt2bdTA0bHXLoh5ilDXrqNqV4-CX_JvQhcACpZbX0tLburJc'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
